import { api } from "./api";

export interface LiveKitTokenResponse {
  token: string;
  url: string;
  room: string;
  identity: string;
  lesson_id?: string;
  is_host?: boolean;
}

export async function fetchAdhocToken(room: string, name?: string): Promise<LiveKitTokenResponse> {
  return api<LiveKitTokenResponse>("POST", "/api/livekit/token", { room, name });
}

export async function fetchLessonToken(lessonId: string): Promise<LiveKitTokenResponse> {
  return api<LiveKitTokenResponse>("POST", `/api/lessons/${lessonId}/token`, {});
}
